export enum StorageType {
  LocalStorage,
  Memory
}
